export default __webpack_public_path__ + "static/media/License-Expired.e4bfdbe4.png";